import { Component } from "@angular/core";

@Component({
  selector: "app-horizontal-slider",
  templateUrl: "./horizontal-slider.component.html",
  styleUrls: ["./horizontal-slider.component.scss"]
})
export class HorizontalSliderComponent {
 
  dragStartX: number = 0;
  scrollLeft: number = 0;

  constructor() { }

  onDragStart(event: MouseEvent) {
    this.dragStartX = event.clientX - this.scrollLeft;
  }

  onDragMove(event: MouseEvent) {
    if (event.buttons !== 1) return;
    const newScrollLeft = event.clientX - this.dragStartX;
    this.scrollLeft = newScrollLeft;
  }
}
